import clsx from 'clsx';
import React from 'react';

import TopicPill from '../Topic/TopicFollowAndTagModal/TopicPill';
import type { SearchPageProps } from './index';

type SearchHeaderProps = Pick<SearchPageProps, 'title' | 'topRelatedEntities'>;

const SearchHeader = ({ title, topRelatedEntities }: SearchHeaderProps) => {
  return (
    <div className="mt-24 mb-12">
      <div className="mt-8 mb-24 text-grayscale-50 font-bold text-headline-sm font-serif">
        Search results for: &ldquo;{title}&rdquo;
      </div>
      <div className="border-solid border-0 border-y border-neutral-300 py-8 text-overline uppercase">
        Related Topics
      </div>
      <div className="mt-12 flex items-center gap-4">
        {topRelatedEntities.map(({ matchingEntity, name }) => (
          <TopicPill
            className={clsx({
              '!bg-primary-red hover:!bg-red-400 !text-white': matchingEntity,
            })}
            key={name}
            topic={name}
          />
        ))}
      </div>
    </div>
  );
};

export default SearchHeader;
